import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createnewfile">
                1.&nbsp;<span className="material-symbols-outlined">note_add</span>&nbsp;{translate('createnewfile')}
            </Typography>
            <p><strong>{translate('createnewfile')}</strong> は、Excelファイルを作成するためのアクションです。デフォルトで生成されるファイルには、<strong>Sheet</strong> という名前のシートが 1 つあります。 </p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイル作成後の保存先</td>
                                <td>$newFileExcel_1</td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイルが保存されるディレクトリ パスです。<strong>/tmp</strong>と入力してルート ディレクトリを指定します。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Excelファイルの名前</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newFileExcel_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('directory')}</span>
                            <div>/tmp/directory-name/</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>file-name.xlsx</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getsheetnames">
                2.&nbsp;<span className="material-symbols-outlined">format_list_bulleted</span>&nbsp;{translate('getsheetnames')}
            </Typography>
            <p><strong>{translate('getsheetnames')}</strong> は、Excelファイル内のシート名をすべて配列として取得するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>シート名取得後の保存先</td>
                                <td>$sheetNames_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイルが保存されるディレクトリ パス</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$sheetNames_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "sheet"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="changesheetname">
                3.&nbsp;<span className="material-symbols-outlined">published_with_changes</span>&nbsp;{translate('changesheetname')}
            </Typography>
            <p><strong>{translate('changesheetname')}</strong> は、Excel ファイル内のシートの名前を変更するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイルが保存されるディレクトリ パス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>変更するシートの元の名前</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('newsheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>シートの新しい名前</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>sheet</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('newsheetname')}</span>
                            <div>new sheet</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="selectsheet">
                4.&nbsp;<span className="material-symbols-outlined">grid_on</span>&nbsp;{translate('selectsheet')}
            </Typography>
            <p><strong>{translate('selectsheet')}</strong> は、シートを選択するアクションです。 Excel で操作を実行するには、まず操作対象のシートを選択する必要があります。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>シート選択後の保存先</td>
                                <td>$workSheet_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイルが保存されるディレクトリ パス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>シートの名前</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>Sheet</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "filePath": "/tmp/directory-name/file-name.xlsx",
                                            "sheetName": "Sheet"
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readcell">
                5.&nbsp;<span className="material-symbols-outlined">font_download</span>&nbsp;{translate('readcell')}
            </Typography>
            <p><strong>{translate('readcell')}</strong> は、ワークシート内のセルの値を読み取るアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>セル読込後の保存先</td>
                                <td>$cellValue_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>該当シート</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>読み取るセルのラベル</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$cellValue_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>123</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writecell">
                6.&nbsp;<span className="material-symbols-outlined">edit_square</span>&nbsp;{translate('writecell')}
            </Typography>
            <p><strong>{translate('writecell')}</strong> ワークシート内のセルの値を書き込むアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>該当シート</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>書き込むセルのラベル</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>書き込む値</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>456</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('newsheetname')}</span>
                            <div>456</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readrange">
                7.&nbsp;<span className="material-symbols-outlined">type_specimen</span>&nbsp;{translate('readrange')}
            </Typography>
            <p><strong>{translate('readrange')}</strong> は、シートの指定範囲内の値を2次元配列に読み取るアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>範囲読込後の保存先</td>
                                <td>$rangeValue_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>該当シート</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>書き込むセルのラベルです。</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$rangeValue_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A1:B2</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                123,
                                                null
                                            ],
                                            [
                                                456,
                                                null
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writerange">
                8.&nbsp;<span className="material-symbols-outlined">app_registration</span>&nbsp;{translate('writerange')}
            </Typography>
            <p><strong>{translate('writerange')}</strong> は、シートの指定範囲内に値を書き込むアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>該当シート</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>書き込むセルのラベル</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>書き込む値</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                123,
                                                "abc"
                                            ],
                                            [
                                                456,
                                                "def"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="deleterange">
                9.&nbsp;<span className="material-symbols-outlined">backspace</span>&nbsp;{translate('deleterange')}
            </Typography>
            <p><strong>{translate('deleterange')}</strong>は、シートの指定範囲内に値を削除するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>該当シート</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>削除セルのラベル</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A1:B2</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="convertexceltocsv">
                10.&nbsp;<span className="material-symbols-outlined">restore_page</span>&nbsp;{translate('convertexceltocsv')}
            </Typography>
            <p><strong>{translate('convertexceltocsv')}</strong> は、Excelファイルのシートを新しいCSVファイルに変換することです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CSV変換後の保存先</td>
                                <td>$excelToCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>該当シート</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CSV ファイルの新しい名前</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>Sheet</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sheet.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writecsv">
                11.&nbsp;<span className="material-symbols-outlined">text_snippet</span>&nbsp;{translate('writecsv')}
            </Typography>
            <p><strong>{translate('writecsv')}</strong> 新しいCSVファイルを作成するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CSV書込後の保存先</td>
                                <td>$newFileCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CSV ファイルの名前</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>CSV ファイルに書き込まれる値です。 (値は2次元配列です)</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$newFileCSV_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>Sample</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "No",
                                                "01",
                                                "02"
                                            ],
                                            [
                                                "Product",
                                                "Pen",
                                                "Note"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readcsv">
                12.&nbsp;<span className="material-symbols-outlined">document_scanner</span>&nbsp;{translate('readcsv')}
            </Typography>
            <p><strong>{translate('readcsv')}</strong> CSVファイルを読込するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CSV読込後の保存先</td>
                                <td>$readCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CSV ファイルのパス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アーカイブの文字エンコーディングを指定します。展開後のファイル名に日本語が含まれる場合、文字化けする可能性があります。文字コードを指定することで文字化けを防ぐことができます。</td>
                                <td>UTF-8</td>
                            </tr>
                            <tr>
                                <td>{translate('headers')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>ヘッダー行として、 <strong>{translate('header')}</strong>スイッチがオン (true) の場合、結果には最初の行も含まれます。</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$readCSV_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('headers')}</span>
                            <div>true</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "No",
                                                "01",
                                                "02"
                                            ],
                                            [
                                                "Product",
                                                "Pen",
                                                "Note"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="changedelimitercsvfile">
                13.&nbsp;<span className="material-symbols-outlined">published_with_changes</span>&nbsp;{translate('changedelimitercsvfile')}
            </Typography>
            <p><strong>{translate('changedelimitercsvfile')}</strong> CSV ファイル内の列を区切る文字を変更するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>区切る文字変更後の保存先</td>
                                <td>$changeDelimiterCsvFile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CSV ファイルのパス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('from')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>現在の区切り文字</td>
                                <td>;</td>
                            </tr>
                            <tr>
                                <td>{translate('to')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>置換したい区切り文字</td>
                                <td>,</td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アーカイブの文字エンコーディングを指定します。展開後のファイル名に日本語が含まれる場合、文字化けする可能性があります。文字コードを指定することで文字化けを防ぐことができます。</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$csvFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('from')}</span>
                            <div>;</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('to')}</span>
                            <div>,</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="appendvaluetocsvfile">
                14.&nbsp;<span className="material-symbols-outlined">post_add</span>&nbsp;{translate('appendvaluetocsvfile')}
            </Typography>
            <p><strong>{translate('appendvaluetocsvfile')}</strong> CSV ファイルに行を追加するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>行が追加後のCSV ファイルの保存先</td>
                                <td>$csvFile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>CSV ファイルのパス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>CSV ファイルに書き込まれる値です。 (値は2次元配列です)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('position')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>追加する行の位置です。ファイルの先頭に追加する値 <strong>0</strong> を指定し、ファイルの末尾に追加する値 <strong>end</strong> を指定します。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('delimiter')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>列を区切るために使用される 1 文字</td>
                                <td>,</td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アーカイブの文字エンコーディングを指定します。展開後のファイル名に日本語が含まれる場合、文字化けする可能性があります。文字コードを指定することで文字化けを防ぐことができます。</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$csvFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "03",
                                                "04"
                                            ],
                                            [
                                                "Ruler",
                                                "Eraser"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('delimiter')}</span>
                            <div>,</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('position')}</span>
                            <div>end</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);